import { Component, ViewChild, inject, input, output } from '@angular/core';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { Paginator } from "src/app/shared/components/paginator/paginator";
import { PaginatorState } from 'primeng/paginator';
import { ButtonModule } from "primeng/button";
import { Popover, PopoverModule } from 'primeng/popover';
import { UserListModel } from '@features/user/models/user.model';
import { SortHeader } from "@shared/components/sort-header/sort-header";
import { BusinessLogo } from "@shared/components/business-logo/business-logo";
import { NotHasRolePipe } from '@shared/pipes/not-has-role.pipe';
import { UserRole } from '@core/auth/services/auth-service';

interface Action {
  key: string,
  label: string
}
@Component({
  selector: 'app-users-list',
  imports: [
    CommonModule,
    TableModule,
    Paginator,
    ButtonModule,
    PopoverModule,
    SortHeader,
    BusinessLogo,
    NotHasRolePipe
],
  templateUrl: './users-list.html',
  styleUrl: './users-list.scss',
})
export class UsersList {
  @ViewChild('popover') popover!: Popover;
  UserRole = UserRole;

  first = input<number>();
  rows = input<number>();
  data = input<UserListModel[]>([]);
  totalRecords = input<number>(0);
  loading = input<boolean>(false);
  selectedUser: UserListModel | null = null;

  pageChange = output<PaginatorState>();
  handleConfirmChangeStatus = output<UserListModel>();
  handleEditUser = output<string>();

  sortBy = input<string | null>();
  sortOrder = input<string | null>();
  toggleSort = output<string>();

  actionsOptions: Action[] = [
    {key: 'edit-user', label: 'Editar usuario'},
    {key: 'change-status', label: 'Cambiar estado'},
  ]

  toggle(event: Event) {
    this.popover.toggle(event);
  }

  selectOption(action: Action) {
    if (this.selectedUser !== null) {
      switch (action.key) {
        case 'edit-user':
          this.handleEditUser.emit(this.selectedUser.Id);
          break;
        case 'change-status':
          this.handleConfirmChangeStatus.emit(this.selectedUser);
          break;
        default:
          this.handleConfirmChangeStatus.emit(this.selectedUser);
      }
    }
    this.popover.hide();
  }

  displayRowActions(event: MouseEvent, user: UserListModel) {
    if (this.selectedUser?.Id === user.Id) {
      this.popover.hide();
      this.selectedUser = null;
    } else {
      this.selectedUser = user;
      this.popover.show(event);

      if (this.popover.container) {
        this.popover.align();
      }
    }
  }

  hidePopover() {
    this.popover.hide();
  }

  handleToggleSort(columnName: string) {
    this.toggleSort.emit(columnName);
  }
}
